import { Box, styled } from '@mui/material';
import { HelixPalette } from '../../helix';
/**
 * Styled button for each toggle button.
 */
export const HelixToggleButton = styled('button')(() => ({
    alignItems: 'center',
    backgroundColor: HelixPalette.white,
    border: `2px solid ${HelixPalette.neutral10}`,
    display: 'flex',
    padding: '0.25rem',
    svg: {
        fill: HelixPalette.neutral50,
        fontSize: '1rem',
    },
    '&:focus': { outline: 'none' },
    '&:focus-visible': {
        svg: { fill: HelixPalette.blue70 },
    },
    '&:hover:not([aria-pressed=true])': {
        backgroundColor: HelixPalette.neutral05,
        cursor: 'pointer',
    },
    '&[aria-pressed=true]': {
        backgroundColor: HelixPalette.teal80,
        borderColor: HelixPalette.teal80,
        svg: { fill: HelixPalette.white },
    },
}));
/**
 * Styled div that contains the toggle buttons.
 */
export const HelixToggleButtonGroup = styled(Box)(() => ({
    display: 'flex',
    'button:first-of-type': {
        borderRightWidth: '1px',
        borderBottomLeftRadius: '0.5rem',
        borderTopLeftRadius: '0.5rem',
    },
    'button:last-of-type': {
        borderLeftWidth: '1px',
        borderBottomRightRadius: '0.5rem',
        borderTopRightRadius: '0.5rem',
    },
}));
